<template>
  <div>
    <div class="index-module_articleWrap_2Zphx" id="artibody">
        <div class="zhemo">『指数』价值投资的四大原则</div>

      <div class="img_wrapper"><span class="img_descr"></span></div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >我们通常说价值投资，这个价值投资到底是什么，它包含哪些比较关键的原则呢？</font
        >
      </p>
      
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="font-L strong-Bold align-Center">
        <font cms-style="strong-Bold font-L align-Center"
          ><font cms-style="font-L strong-Bold align-Center"
            ><font cms-style="font-L strong-Bold align-Center"
              ><font cms-style="font-L strong-Bold align-Center"
                >价值投资理念的诞生</font
              ></font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >说到价值投资，相信很多朋友在网上搜索投资理财相关的书籍，或者是文章的时候，经常看到这个词。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >其实，价值投资最早诞生，是来自于巴菲特的老师格雷厄姆。</font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >那么，在格雷厄姆之前，股票市场最早是怎么来的呢？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">当时欧洲要做航海，是大航海时代。</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >后来发现了美洲，还有很多数不尽的宝藏，有少量的这些船队，远洋的船队最后赚到了钱，大获丰收，发了财，剩下的欧洲人都很眼红。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是远洋航行并不是所有人，都能够去做的，风险太高了，所以当时就有人想出了一个，非常天才的想法，就是股份制公司。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >通过成立一家股份制公司，这个公司去做远洋的贸易，如果谁看好这个生意，就去买这个公司的股票，股份制的公司就这样诞生了。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >最初的股份制的公司是面向贵族、有钱人还有皇室，针对他们开放的。后来股票的交易门槛就逐渐降低了，就普及到了千家万户，当时很多欧洲的普通<span
            id="stock_sh603883"
            >老百姓</span
          ><span id="quote_sh603883"
            ></span
          >，也可以去买股票了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这个公司的数量越来越多，你手里一直都有股票，股票也没办法直接拿过来交易，所以很多人就有变现的需求，他毕竟还是要换成钱。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >另外也有一些人，他想去买这些公司的股票，所以中间就产生了一个交易的需求。所以很多人就约定，在某一个地区，我们就在这个地方去交易股票。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >包括咱们国内，在早期的时候，股票市场还没有建立之前，当时的股票交易，就跟现在北京有的朋友去潘家园摆地摊一样。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >最早的股票交易，就是一个早期的地摊经济。大家支个摊子，在这里把自己的股票凭证摆出来，谁要多少钱，就讨价还价，最后就成交了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是老这样也不行，这种成交的交易的效率，是非常低的，而且不利于交易，毕竟这里边中间有很多的漏洞。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以，后来就专门成立了一个股票交易所，这个交易所就跟我们菜市场一样，咱们圈块地，所有的人都要达到一定的标准和要求。把这个股票，按照标准的份额给拆分好，然后以100股为单位去买卖交易，这就是A股的规则。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >当时的海外市场，也有了这样一个股票交易所，但是仅仅有了这样的一个雏形，并不代表着投资理念就成型了。股票交易所最初诞生了之后，它当时引入了一个很有意思的东西，叫K线。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">K线这个东西是什么呢？</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">K线这个东西，最早是来自于日本。</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >日本的大米交易商，他们用K线来标价标记大米的价格。K线上面主要有4个元素，就是当日的最高价、最低价，还有类似的一些元素。上涨、下跌可能用红色和绿色，分别去表示，所以这个很形象。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以，后来就引入了K线这种方式来计价。&nbsp;</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是引入了之后，并不代表着投资的策略出现了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >当时很多人，就是看这个市场的涨跌去买股票。有哪些品种涨得好，看到过去的几个月，过去一两年涨得好，很多人就进去买了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这种投资策略一直都有，包括像我们非常熟悉的牛顿，牛顿当时也是用这种方式买股票，结果亏了很多。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以再到后来的时候，特别是到了20世纪初的时候，美股在1920年到1929年这段时间，出现了一波非常大幅度的上涨，在1929年就出现了美国当时的一个经济危机。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >1929年的大萧条，股票市场之后跌去了百分之七八十。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >在这一轮大的上涨、大跌之后，市场上就出现了一批人，他们开始反复地思考，为什么市场会出现这样的大涨大跌，究竟有什么样的方式，可以帮助投资者获得一个好的收益？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其中有一个人叫格雷厄姆，他在20世纪20年代的时候，也投资了股票，并且做的规模还不小。但是，在大萧条期间，股市大跌，格雷厄姆当时就濒临破产，不得不回到大学去教书。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >你看人家去当个大学教授，这是不得不去做的一个选择。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >其实他之前自己做生意做投资，做的规模都挺大的。回到学校，他在做投资的时候，就把自己的这些研究，系统性地梳理了出来，出版了一本书《证券分析》，就在大学里，去普及他的投资相关知识。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >有一个小伙子，来自于美国内陆的一个省份，小伙子叫巴菲特，在学校里面上课的时候，接触到了格雷厄姆的这套理念。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >巴菲特，包括后来格雷厄姆的徒子徒孙，就把价值投资这套理念，给发扬光大了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其实不仅仅是巴菲特出名，格雷厄姆当时教出来的，好多的学生后来都很出名，比如说，像擅长低市净率投资的施洛斯，他也是巴菲特的同门师兄弟。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >他跟巴菲特的投资策略和理念，有一些区别，特别是投资的方式上。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold">·&nbsp;</font></font
        ><font cms-style="font-L"
          >巴菲特，后来变成了长期持有一些优质的公司，陪伴公司成长这样的风格，这个也是受他的好朋友、好搭档查理·芒格的影响；</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold">·&nbsp;</font></font
        ><font cms-style="font-L"
          >施洛斯，一直坚持的是格雷厄姆之前的理念，就是低估值投资，所以施洛斯是擅长低市净率投资的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >另外，还有一些投资大师，他们也是或多或少地受到了格雷厄姆的影响。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说，我们前面提到过一个低市盈率投资大师，就是约翰·涅夫。约翰·涅夫在学校的时候，当时教他投资理念的那个人，本身也是格雷厄姆这一派的信徒。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以，我们看到很多的美国投资大师，或多或少的都受到了，格雷厄姆一派的影响。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="font-L strong-Bold align-Center">
        <font cms-style="strong-Bold font-L align-Center"
          ><font cms-style="font-L strong-Bold align-Center"
            ><font cms-style="font-L strong-Bold align-Center"
              ><font cms-style="font-L strong-Bold align-Center"
                >价值投资的四个要素</font
              ></font
            ></font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"></font
        ></font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >我们今天给大家介绍的，价值投资这个理念，究竟包含了些什么？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >虽然每一个投资大师，他们的投资理念不同，但是通常来说，价值投资有4个最基本的要素，这也就是格雷厄姆在他的书里面反复提到过的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >价值投资这4个核心的要素是：买股票就是买公司，要有安全边际的意识，要认识到市场先生，还有明白自己的能力圈。</font
            ></font
          ></font
        >
      </p>
      <div class="img_wrapper">
        <img
          img-size="1080,608"
          src="../../../assets/img/gar8-1.jpg"
          style="max-width: 520px"
          cms-width="677"
          id="3"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其实价值投资，不管最后变成什么样子，基本都是包含了这4个主要的元素。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="font-L strong-Bold align-Center">
        <font cms-style="strong-Bold font-L align-Center"
          ><font cms-style="font-L strong-Bold align-Center"
            ><font cms-style="font-L strong-Bold align-Center"
              ><font cms-style="font-L strong-Bold align-Center"
                >买股票就是买公司</font
              ></font
            ></font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">首先，买股票就是买公司。</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这个理念，我觉得是在一开始投资的时候，非常难入门的一个理念。因为很多人，他是把股票当做是一个筹码，而且这个想法很难改变。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >包括很多市场上的老股民，一提起来就是庄家，有很多人特别喜欢说「庄家」这样的一个词汇。庄家这个词来自于哪儿呢？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >庄家这个词是从赌场来的。坐庄，庄家就是开赌场的，或者说是有大资金量来操纵赌局的。所以像这种庄家，包括股票市场有很多的术语，早期也是来自于赌场。</font
        >
      </p>
      <div class="img_wrapper">
        <img
          id="4"
          img-size="1080,608"
          src="../../../assets/img/gar8-2.jpg"
          style="max-width: 520px"
          cms-width="677"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说，我们通常提到的蓝筹股。蓝筹是什么意思？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >蓝筹就是赌场里边金额最高的筹码。当时是用一个蓝色的筹码，蓝筹股后来就代表了大盘股。</font
          ></font
        ><font cms-style="font-L"></font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以，我们看到股市很多的术语，是从赌博当中继承过来的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >早期的很多人，还通过K线，或者是一些短期的技术，用这种划线的方式，来预测市场的一个涨跌。但这种方式其实主要是观测的这个品种本身价格的涨跌。很少有人去关注背后的公司，它们实际的经营情况。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >格雷厄姆当时就把这个投资理念给升华了，他说买股票就是买公司，买了背后的这个公司，就拥有了公司的部分所有权。</font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">从这个角度出发，研究</font
        ><font cms-style="font-L">的对象就从股</font
        ><font cms-style="font-L"
          >价短期的涨涨跌跌，就变成了研究股票背后的这个公司的经营上。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >像格雷厄姆，他的说法就是这样，他认为一个公司的质量优秀，它的盈利长期上涨，这个盈利的长期上涨，迟早会体现在公司股价的上涨上，这就是「买股票就是买公司」。</font
        >
      </p>
      <div class="img_wrapper">
        <img
          cms-width="677"
          id="5"
          img-size="1080,608"
          src="../../../assets/img/gar8-3.jpg"
          style="max-width: 520px"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >之前也有一个非常形象的比喻，就是主人和小狗的故事。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >股价就是小狗，盈利就是主人，小狗围绕着主人上蹿下跳。但是如果盈利，也就是主人前进1000米，这个小狗迟早也会跟着前进1000米，这就是小狗和主人的一个关系。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">所以，买股票就是买公司。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >那公司得赚钱呀，我们现实生活当中，你跟朋友去开一个公司，或者朋友有一家公司要卖给你，你肯定要先了解一下，这个公司这个生意我做起来，赚不赚得到钱呢？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >如果你那个朋友跟你说，他手里有一家公司，这个公司每年都亏损，你愿不愿意盘下这家公司呢？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">你肯定不愿意，我干嘛要一个亏损的公司呢？</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">你肯定是想要赚钱的公司的。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">我们在现实生活当中，很容易明白这一点。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >没有人想要一家亏钱的公司，但是股票市场里，特别是A股，市场上3000多只股票，实际上有很多的股票，好几百只，它们长期可能都是亏钱的，或者说偶尔赚钱，大多数时间亏钱，像这样的公司，还是有很多人，在市场上交易的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以，买股票就是买公司，你想想在现实生活当中，你怎么去开一家公司？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >无论是创业，还是跟朋友合伙去开一个，还是从朋友手里去收购一家公司，都要先想一想，这家公司它赚不赚钱。</font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >在二级市场，也就是通过股票的账户，通过证券账户，我们去买股票，也是一样的道理。</font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L strong-Bold align-Center">
        <font cms-style="strong-Bold font-L align-Center"
          ><font cms-style="font-L strong-Bold align-Center"
            ><font cms-style="font-L strong-Bold align-Center"
              ><font cms-style="font-L strong-Bold align-Center"
                >要有安全边际</font
              ></font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">第二个理念，就是要有安全边际。</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >我们去菜市场买菜，第一步是看看这个菜的质量好不好，第二步就是跟菜贩子讨价还价，能不能给我一个便宜的价格。</font
        >
      </p>
      <div class="img_wrapper">
        <img
          cms-width="677"
          id="6"
          img-size="1080,608"
          src="../../../assets/img/gar8-4.jpg"
          style="max-width: 520px"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L"><font cms-style="font-L">买公司也一样的。</font></p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >▼第一步，我们得看，这个公司赚不赚钱，这个公司本身亏钱的话，你肯定就不考虑了。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >虽然说亏钱的公司，它有可能扭亏为盈，最后也有可能是从困境当中走出来。但是更多的公司，它是直接就一路亏下去，最后就没了，我们第一步要确认，这是个好公司。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >▼第二步，就要找一个好的价格了，如果一个东西，你知道它价值一块钱，你愿不愿意用一块钱去买？</font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"></font
        ></font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >你肯定不愿意，一块钱的东西我用一块钱买，那我还有什么赚头，1块钱的东西我要是能用6毛钱，甚至用4毛钱买下来，那我才有赚头。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这个很容易理解，我们在现实生活做生意的时候，一块钱进的货，我一块钱卖掉，那我根本啥都不赚，除非说我是4毛进的货，我1块钱卖掉，我才能够赚到中间的收益。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >所以买入的这个公司，本身有自己的一个客观价值。这个价值我们用一些估算的方法能够估算出来，也就是估值。</font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说，像我们通常说的市盈率、市净率，这种相对估值的方法，还有现金流折现，这种绝对估值的方法，这些方法，估算出来的公司的价值，并不代表它一定就是这个价，但是好歹是有一个估算的价值。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >就好比你去超市，你看到一个西瓜，虽然说你不知道这个西瓜，精准的价值是多少，但你能够估个大概。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >如果超市这个西瓜，是一毛钱一斤，那你肯定知道，这个是低于它的价值的，你就愿意买这个西瓜。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >如果超市标的价格，5块钱一斤，你就觉得有点贵了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >正常情况下，夏天的时候，西瓜应该是两三块钱一斤，那5块钱也太高了，你就马上知道了，虽然你不知道西瓜的精准价值，但是你不需要精准，你就知道个大概，是可以估算出来的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >之前关于安全边际，也有一个非常形象的比喻，我发现这些投资大师，都很擅长打比方，这个形象的比喻是什么呢？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >你不需要知道一个人的体重，你也能够看出，他是个胖子还是瘦子。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">所谓的安全边际，就是一眼胖瘦。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >你也不需要知道，他的真正的体重的精确数字是多少，但你一眼看过去他是个胖子，那也差不了多少。一眼看上去他很瘦，那也差不了多少，所以这个就是安全边际的一个意识。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >我们没有办法，精准地判断价值。但是能够判断个大概，比这个数值低一些，保留安全边际，这样能够买的便宜一些。</font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L strong-Bold align-Center">
        <font cms-style="strong-Bold font-L align-Center"
          ><font cms-style="font-L strong-Bold align-Center"
            ><font cms-style="font-L strong-Bold align-Center"
              ><font cms-style="font-L strong-Bold align-Center"
                >认识市场先生</font
              ></font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">第三个理念，是市场先生。</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >市场先生，是一个非常有趣的比喻，因为我们在做投资的时候，其实买入和卖出，操作这个时间，就是那么一瞬间就操作完了，不会花太长时间。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其他的很长一段时间，要不就是我们拿着现金等机会，要不然就是我们持有股票，耐心地等待上涨。但是中间这个市场的价格，是有波动的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >以前买银行理财的很多朋友，明显就感觉到了，以前的银行理财，和今年的银行理财，是有区别的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">以前的银行理财，你是看不见涨跌的。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说，买三个月的银行理财，到了第三个月的时候就给你，本金还有利息了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是，今年我们看到，很多银行的银行理财，已经变成净值型的了。所谓的净值型理财，就跟债券基金是一样的，每天会有一个净值报出来，这个净值每天会有涨跌。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">前段时间就有一个新闻。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >之前<span id="stock_sh600036"
            >招商银行</span
          ><span id="quote_sh600036"
            ></span
          >，发了一个净值型的理财，结果净值型的理财，就是前段时间债券大跌的时候，这个净值型理财也亏了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >很多人都很害怕，因为他以前买理财，没看到过下跌，其实如果真的拿个3个月到6个月，还是大概是赚钱的，但是中间可能有几天，或者是几周的时间，会出现一定的波动。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">到了股票市场，这个波动就更大了。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说像我们前段时间投的中概股。看今年就知道了，中概股年初的时候大涨，3月份暴跌，然后快速反弹又大涨。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >看到它的起点和终点，如果说以5年的时间来看，是上涨的。但是你看中间的某一年，仅仅是今年这几个月，半年的时间，就上蹿下跳了好几次。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >格雷厄姆，把这个比喻为一个市场先生。</font
            ></font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >市场先生是一个狂躁的、精力旺盛的、喜怒无常的人，他每天的工作，就是跑过来给你报价格。</font
            ></font
          ></font
        >
      </p>
      <div class="img_wrapper">
        <img
          id="7"
          img-size="1080,608"
          src="../../../assets/img/gar8-5.jpg"
          style="max-width: 520px"
          cms-width="677"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"></font
        ></font>
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >有的时候，他非常的乐观，给你报一个很高的价格；</font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold">有的时候，他非</font></font
        ><font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >常的悲观，给你报一个非常低的价格。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >你并不需要，他给你报价的时候，你就要行动。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >有的人，他特别容易受到市场的影响，市场给他报个价格，他就马上会被影响到。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >有的时候，市场给他报个高价，他这个时候也很乐观，被市场传染了。有的时候，市场给他报个低价，他就很悲观，也被市场传染了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >其实真正有一定心理素质，或者说有了投资经验的人，不会太被市场影响。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">市场先生，其实是一个非常难的事情。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >虽然我们在这里说，我感觉想理解市场先生，其实比前面说那两点，还要难一些。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >因为前面的，无论是安全边际，还是说买股票就是买公司，这两个其实只要建立起了相关的认知，马上就能够理解了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">但是到了市场先生是很难的，为什么呢？</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这里面有个很有意思的情况，我们在这里说市场先生，感觉他是一个虚构出来的角色，但是到了真正投资的时候，特别在市场大涨大跌的时候，往往会出来一些非常有名的人，他们充当了市场先生的角色。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说，市场暴跌的时候，这个时候会有人站出来说，A股要跌到1000多点，这个人可能又比较有名，到了市场上涨的时候，我们又看到有些券商站出来说，可能是券商的经济首席，甚至是一些非常知名的基金经理，站出来说，5000点是牛市新起点。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">那你这个时候，信还是不信呢？</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这个时候他的发言，你就会想，他这么厉害，他这么出名，是不是他说的就是对的呢？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">其实说的也不一定</font
        ><font cms-style="font-L">对。但是你在</font
        ><font cms-style="font-L"
          >那个时间段，如果市场上有人喊出来了这个，很多人就真的信了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >所以说，这个市场先生，我觉得是比较难的，因为人的本能是从众，这个是人类在漫长的进化当中，养成的一个天性。</font
          ></font
        >
      </p>
      <div class="img_wrapper">
        <img
          id="8"
          img-size="1080,608"
          src="../../../assets/img/gar8-6.jpg"
          style="max-width: 520px"
          cms-width="677"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">其实，这个天性在很多时候是很有用的。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说，我们不知道，前面发生了什么危险，假如一群人往前走，你不知道前面发生了什么危险，但你看到前面的人，在惊慌失措地往回跑，你这个时候跟着往回跑，能够让你快速地避开一些自然的灾难。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是，到了金融市场，如果这样做的话，反而就没办法去从中获利了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >关于市场先生，还有群体的非理性，之前有一本书叫《乌合之众》，这本书其实更加详细地，介绍了这一点。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold">人的本能是从众。</font></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >特别是当群体一起形成了一个方向，形成了一个趋势的时候，这个从众的心理，影响是非常大的。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以我觉得，这个市场先生，其实告诉我们，就是市场的涨跌，是没有办法判断的。因为市场先生是一个狂躁不安的，又会经常向你报价的人。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >你需要做的是，首先建立起自己的一套投资体系，清楚地知道这个品种，到底值多少钱。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">这个值多少钱，是你的一个锚。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >就在这个地方，就把你的这个锚放下了。无论市场怎么上涨下跌，你这个锚就在这里定住了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >你就知道，市场涨起来很贵的时候，这个时候不能追涨，远远超过了你心里的这个锚。市场下跌，跌的比你这个锚还要低很多的时候，你就可以想，我要不要在这里再加点仓。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >所以，市场先生是告诉我们这个市场，它是波动比较大，喜怒无常的，但是我们自己内心，要有一个相对客观的标准，帮助我们去做一个决策，避免受到市场的影响。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如美股，前段时间就是非常典型的一个特征。</font
        >
      </p>
      <div class="img_wrapper">
        <img
          id="9"
          img-size="1080,608"
          src="../../../assets/img/gar8-7.jpg"
          style="max-width: 520px"
          cms-width="677"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >我们看到这张图里，是纳斯达克100，在过去这段时间的一个涨跌幅。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >在短短一个月的时间里边，纳斯达克100就先是暴跌了36%，然后又涨回去了，超过了前期的高位。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是，这段时间，仅仅是一个多月，企业真的有这么大的变化吗？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L"><font cms-style="font-L">其实根本没有。</font></p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >一个多月的时间，企业哪来得及变化，它背后体现的，就是市场先生。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说到了1月份的时候，敲你的门，给你报一个特别高的价。到3月份的时候，又敲你的门，给你报了一个特别低的价。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >又过了两个月，又敲了一个门，又给你报了一个很高的价格。所以市场本身是喜怒无常的。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="font-L strong-Bold align-Center">
        <font cms-style="strong-Bold font-L align-Center"
          ><font cms-style="font-L strong-Bold align-Center"
            ><font cms-style="font-L strong-Bold align-Center"
              ><font cms-style="font-L strong-Bold align-Center"
                >明白能力圈</font
              ></font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">最后一点也是比较困难的，就是能力圈。</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >能力圈其实用一句话来概括，就是没有金刚钻，不揽瓷器活。</font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是，有一个非常麻烦的地方，就是人很难去判断，自己能力到底有多大。因为大多数人的本能，是倾向于高估自己的能力。</font
        >
      </p>
      <div class="img_wrapper">
        <img
          id="10"
          img-size="1080,608"
          src="../../../assets/img/gar8-8.jpg"
          style="max-width: 520px"
          cms-width="677"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"></font
        ></font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">我这里说两个案例，大家就马上明白了。</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说，每个人都希望自己的孩子能够考得比较好。但是如果一个班上有50个学生，肯定有第一名，有倒数第一名，但是大多数的家长都认为，特别是在自己孩子上学之前，都会认为自己的孩子能够考到班级的前四分之一。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >包括之前也有一个统计，对司机的一个调查，这个也很经典了。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >大部分的司机，都认为自己的驾驶能力，超过了平均值。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但这是不可能的，平均值是中位数，但是大多数的司机，都认为自己的驾驶能力，超过了中位数。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >所以人的本能，是倾向于高估自己的能力。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这种情况下，在投资的时候，也经常容易犯错。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >包括前几天学院里面，有一个朋友发了一个帖子问，钱少的时候要不要冒风险，以小博大，去抓这些机会？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其实这个就是，高估自己能力的一个体现。为什么呢？</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >人在社会上能够拿到多少的钱，是社会对他这个人的人力资产的一个评估。如果说手头的钱比较少，那说明自己个人的能力，可能还是有所欠缺的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >这个时候，优先要提高自己的能力，而不是想着以小博大。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >因为所有人都想以小博大，以小博大是一个稀缺的资源，我们如果在社会上没有办法，获得一个好的收入的话，那凭什么能够在这种竞争很激烈的市场，战胜其他竞争对手呢？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以，我们也会倾向于高估自己的能力。其实这个时候我们需要做的，就像巴菲特说的，你去找一些能够轻松跨越的栏杆，然后越过去，这个就是能力圈了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >能力圈并不代表，你掌握的东西越多越好，而是清楚地知道自己能力圈的边界。</font
          ></font
        >
      </p>
      <div class="img_wrapper">
        <img
          id="11"
          img-size="1080,608"
          src="../../../assets/img/gar8-9.jpg"
          style="max-width: 520px"
          cms-width="677"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说，我们刚才说过的，就是早期的股票市场，当时牛顿就在泡沫最大的阶段，把自己的家产投入到了南海公司的股票，差点倾家荡产。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >牛顿可以说是整个人类史上，绝对是最聪明的人之一，但是就算是他，也算不清人性的疯狂，特别是资本市场的疯狂。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="font-L strong-Bold align-Center">
        <font cms-style="strong-Bold font-L align-Center"
          ><font cms-style="font-L strong-Bold align-Center"
            ><font cms-style="font-L strong-Bold align-Center"
              ><font cms-style="font-L strong-Bold align-Center"
                >长期资本公司LTCM的溃败</font
              ></font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这里再说一个非常形象的例子，就是长期资本公司。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >长期资本公司是上世纪90年代，一个非常典型的，就是超过了自己能力圈，做了自己能力圈范围之外的事情，导致最后亏损失败的这样的一个案例。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这家公司是成立于1994年，公司成立之初，是非常豪华的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >首先它的发起人被称为华尔街债券套利之父，他发起这家公司的时候，邀请了两位诺贝尔经济学奖得主，跟他一起做。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以这家公司从一开始，就是非常辉煌的一家公司，可以说智力密度在当时的华尔街是最高的。</font
        >
      </p>
      <div class="img_wrapper">
        <img
          id="12"
          img-size="1080,608"
          src="../../../assets/img/gar8-10.jpg"
          style="max-width: 520px"
          cms-width="677"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这样一家公司，开始的时候做的业务，主要是对冲基金。他怎么做呢，利用数学模型，去做一些债券套利。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >债券本身的波动，确实比股票要小，所以，如果发现了有个套利的机会，他们会在这上面加杠杆，来放大收益。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >用这种方式，只要说债券的套利，假如说能套到一个0.5%，再加个10倍的杠杆，可能就套到一个5%的收益了。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >1994年到1997年，他们做的收益确实是非常棒的。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >我们看到这张图，这张图里面这条蓝色的曲线，就是当时他们对冲基金的一个走势图了。</font
        >
      </p>
      <div class="img_wrapper">
        <img
          img-size="1080,608"
          src="../../../assets/img/gar8-11.jpg"
          style="max-width: 520px"
          cms-width="677"
          id="13"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >我们看到，股票市场的走势，远远比不上他们同期对冲基金的走势。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >1994年的时候，他们的基金盈利28个点，1995年盈利43个点，1996年盈利41个点，1997年盈利17个点。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >单看这个业绩，简直是太辉煌了，特别是对于投资债券套利，这样的一个策略来说，这个收益是非常好的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">但是，1998年的时候，发生了一个意外。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >当时因为全球的油价暴跌，感觉跟今年有点像，原油的价格暴跌，他们当时就投了一些海外的一些相关的债券，结果遇到了俄罗斯的股市、债市崩盘，他们当时下注于债券套利就失败了，又在上面上了很高的杠杆，所以导致他们的对冲基金，在两个月的时间里面迅速暴跌，然后爆仓了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这也就是我们看到这张图里面，右侧的那条线，所以这个公司，在很短的时间内，直接就溃败了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是，他们倒闭了之后，并不死心，只是觉得自己很倒霉，遇到了一个很长时间都遇不到的一个问题，遇到黑天鹅了，这不是投资能力问题。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以，公司倒闭了之后，1999年同样一拨人，他们再次成立了对冲基金，换了一个名字，采用同样的策略，结果到2008年金融危机的时候，再次亏掉了44%，又清盘了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >第二次就绝对不是运气问题了，这说明策略本身是有缺陷的。为啥呢？</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其实如果仅仅是简单地去做债券套利的话，他们是很难出现特别大的浮亏的。问题的难点是在上面加了杠杆，杠杆可以加到无限高。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >对他们来说，可以加到非常非常高，这种情况下，就会放大了未来可能出现的这些风险，带来的这个损失。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这个杠杆加得越高，就会超过他们能力圈，总有一次他们会遇到，超过他们能力圈的风险。就会导致基金再次出现了亏损清盘。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >我一直跟大家说，投资基金的时候，如果拿不准，可以从宽基指数入手。为啥是从指数基金去入手？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >因为指数基金有一个好处，它不太需要多大的能力圈，你可以轻轻松松地拿到市场平均收益，因为它是把整个市场买下来。包括宽基指数，还有一些优秀行业指数。</font
            ></font
          ></font
        >
      </p>
      <div class="img_wrapper">
        <img
          cms-width="677"
          id="14"
          img-size="1080,608"
          src="../../../assets/img/gar8-12.jpg"
          style="max-width: 520px"
        /><span class="img_descr"></span>
      </div>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"></font
        ></font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >如果说我们要挑一些行业，特别是细分行业，就要想一想，我们在这个细分行业上，有没有自己能力圈呢？我们对这个行业的判断，是不是能够领先于市场上大部分人？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >比如说，之前有朋友经常问，像新能源车、像这种芯片半导体，为什么我们没有投？</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其实像这些行业，变化得实在太快了，而且处于高速发展的一个阶段，本身又比较细分，我们如果判断不好这个行业未来的变化，那我们凭什么在市场上能战胜其他的投资者，拿到</font
        ><font cms-style="font-L"></font><font cms-style="font-L">收益？</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L"><font cms-style="font-L">其实这个很难的。</font></p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是，如果你买的是一个宽基指数，把整个市场买下来，你可以获得市场整体的一个平均收益水平，这个就不需要太大的能力圈了。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >在这个基础上，如果你想要投资细分行业，你需要对细分行业有能力圈。如果你想要挑战个股，那你需要对个股有能力圈。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">其实能力圈，并不代表说能力大小。</font>
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >如果说你没有这个能力圈，没有个股投资能力圈，觉得自己有了，去投了这个个股，也有可能还不如投指数基金赚的钱多。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="strong-Bold font-L"
          ><font cms-style="font-L strong-Bold"
            ><font cms-style="font-L strong-Bold"
              >所以，能力圈的大小不是关键，知道自己能力圈的大小才是关键。</font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以我觉得，能力圈这个理念，其实可以用两句话概括：</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >·&nbsp;第一句话，没有金刚钻，不揽瓷器活；</font
          ></font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >·&nbsp;第二句话，知之为知之，不知为不知。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">这是能力圈非常经典的一个概括。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其实咱们以前的老祖宗，总结的已经非常棒了，这个就是能力圈的问题。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >我觉得，开始的时候，指数基金，比较适合用来搭建能力圈的。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说宽基指数，就那么几只最经典的，上证50、沪深300、中证500，顶多再加个创业板，这就是A股4大宽基。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">港股就是恒生、H股、香港中小这几只。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">美股的话，就是标普500、纳斯达克。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >日本是日经225，英国的话就是富时100，法国是CAC40指数。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这些国家，代表性的宽基指数比较少，而且可以说，这个国家股票市场还在的话，这个宽基指数就会一直在。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">20年后A股还在，沪深300就在。</font>
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >所以，像这种宽基指数，本身很稳定，也不太需要太多能力圈，可以作为开始接触股票类资产的一个入门选择。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >学会了这个，在这个上面，下一步可以研究一些细分优秀行业。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >比如说之前看了彼得·林奇，还有一些其他投资大师的书，他们也是建议普通投资者如果要研究行业的话，可以先从消费入手。消费是最容易理解的，变化也没那么快。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">其他两个优秀行业，是医药和互联网。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >医药行业对专业性有一点要求，你需要了解一些专业的知识，还有相关的术语，入门的门槛会高一点，互联网行业，收益很好，只是变化得很快。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >所以像互联网行业，谁也不知道，几年之后是什么样的。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L">2018年的时候，市场对腾讯很失望。</font>
      </p>
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >因为2018年，腾讯的股价跌得挺多的。到今年，又换成了阿里巴巴，市场对阿里巴巴比较失望。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >今年其他的互联网公司，涨得都很好，就阿里巴巴涨得不太好，再过两年又是什么样？</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >说不定到时候，美团把阿里巴巴战胜了，到时候说不定B站又崛起了，谁也不知道。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是，这也是互联网行业的一个魅力所在，我觉得像这些行业，优先从消费、医药、科技，科技包括互联网，从这几个行业入手是事半功倍的。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >其实，这些行业有一个共同的特点，也就是我们给大家讲的护城河，这些行业通常会有一到多个不等的护城河，来帮助它们长期获得一个不错的收益。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >所以，投资没有必要，没有困难创造困难也要上。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >刚才说的这个长期资本公司，他们就属于没有困难创造困难也要上。因为加了更多的杠杆，最后这个杠杆，总有一天超过了他们的策略能够承受的一个上限。</font
        >
      </p>
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="font-L strong-Bold align-Center">
        <font cms-style="strong-Bold font-L align-Center"
          ><font cms-style="font-L strong-Bold align-Center"
            ><font cms-style="font-L strong-Bold align-Center"
              ><font cms-style="font-L strong-Bold align-Center"
                >总结</font
              ></font
            ></font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >这就是我们今天给大家介绍的，价值投资理念，包含的4个方面。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >第一，买股票就是买公司，我们要有这样的一个认知。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >第二，要有安全边际的意识，要买得便宜。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >一块钱买一块钱的东西，是不赚钱的，我们得用6毛买1块，或者用4毛买1块的东西，才能赚到钱。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >第三，我们要认识到市场的波动，也就是市场先生，他是一个狂躁的，喜怒无常的，每天坚持向你报价的人。</font
          ></font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc " cms-style="font-L">
        <font cms-style="font-L"
          >但是，我们不要受他的影响，就坚持自己的一套买入卖出规则。</font
        >
      </p>
      
      <p class="index-module_textWrap_3ygOc  szhuang" cms-style="strong-Bold font-L">
        <font cms-style="font-L strong-Bold"
          ><font cms-style="font-L strong-Bold"
            >最后，是明白自己的能力圈，这个能力圈不在于大小。</font
          ></font
        >
      </p>
      
     
      <!-- 开户二维码 end -->

      <!-- 正文下iframe -->

      <!-- 正文下iframe -->

      <!-- 总声明-->

      <!-- 总声明-->

      <!-- 文末二维码 start -->

      <!-- 文末二维码 start -->
      
      
      <!-- 文末二维码 start -->

      <!-- 文末二维码 start -->

      <!-- 编辑姓名及工作代码 -->

      <!-- 编辑姓名及工作代码-->

      
      <div style="font-size: 0px; height: 0px; clear: both"></div>
    </div>
    <p class="free">（来源：银行螺丝钉）</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>